import { translate } from './translate';

export const translateOptionsList = (items: {key: string, value: string}[]) => items.map(item => ({
  key: item.key,
  value: translate({ key: item.value })
}));
